import { UserRound } from 'lucide-react';
import { AqlSeahorseLogo } from '@/app/components/branding/aql-vision-brand';
import type { AqlAssistantMessage as AqlAssistantMessageType } from './useAqlAssistant';

export function AqlAssistantMessage({ message }: { message: AqlAssistantMessageType }) {
  const isUser = message.role === 'user';

  return (
    <div className={`flex gap-2.5 ${isUser ? 'justify-end' : 'justify-start'}`}>
      {!isUser ? (
        <span className="mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-xl border border-primary/20 bg-white/90 p-1 shadow-inner">
          <AqlSeahorseLogo className="h-full w-full object-contain" alt="" />
        </span>
      ) : null}
      <div className={`max-w-[88%] rounded-2xl border px-3.5 py-3 ${
        isUser
          ? 'border-primary/28 bg-primary text-primary-foreground'
          : 'aql-assistant-surface border-border bg-muted/45 text-foreground'
      }`}>
        <div className="whitespace-pre-wrap text-sm leading-6">{message.content}</div>
      </div>
      {isUser ? (
        <span className="mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-xl border border-border bg-card text-primary">
          <UserRound className="h-4 w-4" />
        </span>
      ) : null}
    </div>
  );
}
